import { useMemo, FC } from 'react'
import { useAtomValue } from 'jotai'
import { Colors, Shapes } from 'src/components/theme'
import { SidebarHeader } from 'src/v2/components/sidebar-header'
import { HeaderCover } from 'src/v2/components/sidebar-header-cover'
import AddressHeaderBG from 'src/assets/images/map-explorer/address-header.svg'
import { StoreAlt } from '@emotion-icons/fa-solid/StoreAlt'
import { useMapExplorerNavigation } from 'src/views/map-explorer/sidebar/search/use-navigation'
import { SidebarHeaderContent } from 'src/v2/components/sidebar-header-content'
import { BASE_IMAGE_URL } from 'src/common-services/types/brand-logo-types'
import { FlexColumn } from 'src/components/flex-containers'
import { prettyNumber } from 'src/utils/number-format'
import { Typography } from '@mui/material'

import * as coreAtoms from 'src/v2/state/core'
import { InsightEmpty } from 'src/views/insight-empty'
import styled from '@emotion/styled'

const Content = styled(FlexColumn)`
  padding: ${Shapes.spacing[5]}px 0;
`

type MapExplorerSelectedBrandProps = {
  showNavigationActions?: boolean
}

export const MapExplorerSelectedBrand: FC<MapExplorerSelectedBrandProps> = ({ showNavigationActions = false }) => {
  const selectedEntity = useAtomValue(coreAtoms.selectedEntity)
  const { clearSelected, goBack, getBackText } = useMapExplorerNavigation()

  const bgImage = useMemo(() => {
    if (!selectedEntity || selectedEntity.type !== 'SELECTED_BRAND') {
      return null
    }
    const logo = selectedEntity.data?.logos?.[selectedEntity.data?.logos?.length - 1]
    const logoUrl = logo ? `${BASE_IMAGE_URL}${logo}` : AddressHeaderBG
    return logoUrl
  }, [selectedEntity])

  const onClose = async () => {
    await clearSelected()
  }

  if (!selectedEntity || selectedEntity.type !== 'SELECTED_BRAND') {
    return null
  }

  const brand = selectedEntity.data

  return (
    <>
      <SidebarHeader
        cover={
          <HeaderCover
            brandId={brand.id}
            icon={<StoreAlt color={Colors.purpleDark} />}
            image={bgImage}
            imageFit="cover"
            badge="Brand"
            onClose={showNavigationActions ? onClose : undefined}
            backText={showNavigationActions ? getBackText() : undefined}
            onBackClick={showNavigationActions ? goBack : undefined}
          />
        }
        content={
          <>
            <SidebarHeaderContent title={brand.name || 'Brand'}>
              <FlexColumn gap={Shapes.spacing[1]}>
                <Typography variant="text1m">Locations {prettyNumber(brand.totalLocations)}</Typography>
              </FlexColumn>
            </SidebarHeaderContent>
          </>
        }
      />
      <Content gap={Shapes.spacing[1]}>
        <InsightEmpty
          title="Coming Soon!"
          message="This feature is coming soon. Please check back soon for more information."
        />
      </Content>
    </>
  )
}
